// extracted by mini-css-extract-plugin
var _1 = "DevReportProblemView__banvasWrapper--N34hZ";
var _2 = "DevReportProblemView__main--dQPc5";
var _3 = "DevReportProblemView__modalClose--elWzX";
var _4 = "DevReportProblemView__problemsBackdrop--nToz9";
var _5 = "DevReportProblemView__problemsBackdropWrapper--U1bQH";
var _6 = "DevReportProblemView__problemsModal--Dm52V";
var _7 = "DevReportProblemView__reportViewButton--mehtD CoreGeneral__roboto--UlmjE";
var _8 = "DevReportProblemView__sectionTitle--RgzdE";
export { _1 as "banvasWrapper", _2 as "main", _3 as "modalClose", _4 as "problemsBackdrop", _5 as "problemsBackdropWrapper", _6 as "problemsModal", _7 as "reportViewButton", _8 as "sectionTitle" }
